export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9612.122542a3.jpg";